import React from 'react';

import { getFormattedTimeLabel } from '../deliveryWindows/scheduled-delivery-utils';
import PropTypes from 'prop-types';

import styles from './PreviewSlot.module.css';

const PreviewSlot = ({
  displayDayIdx,
  label,
  isDisabled,
  slotOpenMS,
  currentTimeMS
}) => {

  const disabledStyle = isDisabled ? styles.disabled : '';
  const todaysDate = new Date(currentTimeMS);
  const openAtDate = new Date(slotOpenMS);
  const willOpenToday = openAtDate.getDay() === todaysDate.getDay(); 

  return (
    <div className={`${styles.timeSlot} ${disabledStyle}`} data-slot-enabled={!isDisabled}>
      <div className={styles.label}>
        {label} 
        { isDisabled
          ? <span className={styles.disabledMsg}>
            { displayDayIdx === 0
              ? willOpenToday
                ? <>Available at {getFormattedTimeLabel(openAtDate.getHours(), openAtDate.getMinutes())}</>
                : <>No Longer Available</>
              : <>Not Yet Available</>
            }
            </span>
          : <span className={styles.enabledMsg}>Available</span>  
        }
      </div>
    </div>
  )  
}

PreviewSlot.propTypes = {
  displayDayIdx: PropTypes.number.isRequired,
  label: PropTypes.string.isRequired,
  isDisabled: PropTypes.bool.isRequired,
  slotOpenMS: PropTypes.number.isRequired,
  currentTimeMS: PropTypes.number.isRequired
};

export default PreviewSlot;